import { lazy } from "react";
const CodingOpV3WorklistPage = lazy(() => import("./pages/CodingOpV3WorklistPage"));
const PatientDetailPage = lazy(() => import("./pages/PatientDetailPage"));
const AiCodingClinicalNotePage = lazy(() => import("./clinical-notes/AiCodingClinicalNotePage"));
export const codingOpportunitiesRoutes = [
  { path: "/coding-opportunities", element: <CodingOpV3WorklistPage /> },
  { path: "/coding-opportunities/patient/:cipId", element: <PatientDetailPage /> },
  { path: "/coding-opportunities/clinical-notes/ai", element: <AiCodingClinicalNotePage /> },
];

export { CodingOpV3WorklistPage, PatientDetailPage, AiCodingClinicalNotePage };
